import { render, staticRenderFns } from "./PaymentInputs.vue?vue&type=template&id=22c7389d&scoped=true"
import script from "./PaymentInputs.vue?vue&type=script&lang=js"
export * from "./PaymentInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7389d",
  null
  
)

export default component.exports